import { render } from "./Selector.vue?vue&type=template&id=467e5464"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
script.render = render

export default script